<div *ngIf="formulaire">
  <div class="form-row mx-1 pt-3">
    <div class="col-md-3">
      <bis-filtered-select-input-keypad [rootForm]="formulaire" label="etape" libelle="Étape du questionnaire" [montreCode]="false" 
                                        nomNomenclature="etape"></bis-filtered-select-input-keypad>
    </div>
    <div class="col-md-4">
      <bis-filtered-select-input-keypad [rootForm]="formulaire" label="niveauErreur" libelle="Niveau d'erreur du questionnaire" [montreCode]="false" 
                                        nomNomenclature="niveauErreur"></bis-filtered-select-input-keypad>
    </div>
    <div class="col-md-5"></div>
    <div class="col-md-4 pt-3">
      <p><b>Total structure(s) : {{ getTotal() }} </b><br></p>  
      <p>
        <ng-container *ngFor="let compteur of getComptage()">
          <i>- {{ compteur[0] }} : </i> <b>{{ compteur[1] }}</b> <br>
        </ng-container>
      </p>
   </div>    
  </div> 
</div>
<br>

<div class="col-12">
  <button
            (click)="exportCSV()"
            class="btn btn-style btn-secondary"
            title="Exporter les données 'Total structure(s)' en csv">
            <i class="material-icons md-18 mr-1" aria-hidden="true"
              >file_download</i>Export Csv
  </button>
  <button class='btn btn-info ml-2 my-2' title="Rafraîchir la liste affichée" (click)='recharger()'>
    <i class="material-icons md-18 mr-1" aria-hidden="true"
              >refresh</i>Rafraîchir
  </button>
</div>  

<div class="col-12 mt-2">
  <mat-form-field class="mat-form-field">
    <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Filtre">
  </mat-form-field>
</div>

<div class="mat-elevation-z8 pb-3">
  <table mat-table [dataSource]="dataSource" matSort>

    <!-- typStruct Column -->
    <ng-container matColumnDef="typStruct">
      <th style="width: 16%" class="text-left" mat-header-cell *matHeaderCellDef mat-sort-header>Type de structure</th>
      <td style="width: 16%" class="text-left" mat-cell *matCellDef="let row"> {{row.typStruct}} </td>
      <td style="width: 16%" class="text-left" mat-footer-cell *matFooterCellDef> Total </td>
    </ng-container>

    <!-- nomStruct Column -->
    <ng-container matColumnDef="nomStruct">
      <th style="width: 40%" class="text-left" mat-header-cell *matHeaderCellDef mat-sort-header>Nom de la structure</th>
      <td style="width: 40%" class="text-left" mat-cell *matCellDef="let row"> {{row.nomStruct}} </td>
      <td style="width: 40%" class="text-left" mat-footer-cell *matFooterCellDef> {{ getTotal() }} </td>
    </ng-container>

    <!-- etape Column -->
    <ng-container matColumnDef="etape">
      <th style="width: 10%" class="text-left" mat-header-cell *matHeaderCellDef mat-sort-header>Étape</th>
      <td style="width: 10%" class="text-left" mat-cell *matCellDef="let row"> {{row.etape}} </td>
      <td style="width: 10%" class="text-left" mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <!-- niveauErreur Column -->
    <ng-container matColumnDef="niveauErreur">
      <th style="width: 10%" class="text-center" mat-header-cell *matHeaderCellDef mat-sort-header>Niveau d'erreur</th>
      <td style="width: 10%" class="text-center" mat-cell *matCellDef="let row"> {{row.niveauErreur}} </td>
      <td style="width: 10%" class="text-center" mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <!-- ielst Column -->
    <ng-container matColumnDef="ielst">
      <th style="width: 10%" class="text-center" mat-header-cell *matHeaderCellDef>Recharger le questionnaire</th>
      <td style="width: 10%" class="text-center" mat-cell *matCellDef="let row">
        <a (click)="charge(row)" tabindex="99">
          <i title="Charger le questionnaire" class="material-icons">
            refresh
          </i>
        </a>
      </td>
      <td mat-footer-cell *matFooterCellDef></td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

    <!-- Possibilite affichage du Total -->
    <!--<tr mat-footer-row *matFooterRowDef="displayedColumns" class="footer-row"></tr>-->

  </table>

  <mat-paginator class="pb-3 pt-3" [pageSizeOptions]="[15, 100]"></mat-paginator>
</div>
